<template>
    <div class="media-portal">
        <div class="media-portal--inlay">
            <div class="media-portal--content">
                <cmp-carousel-slider class="media-portal--slider"
                        :items="sortedItems"
                        :idx="idx"
                        :passive-mode="true"
                        @request-change="updateIdx($event)">
                    <template slot="item" slot-scope="props">
                        <component :is="props.item.type" v-bind="props"></component>
                    </template>
                    <template slot="arrow-nav" slot-scope="props">
                        <cmp-carousel-arrow-nav v-bind="props"></cmp-carousel-arrow-nav>
                    </template>
                    <template slot="bullet-nav" slot-scope="props">
                        <cmp-carousel-bullet-nav v-bind="props"></cmp-carousel-bullet-nav>
                    </template>
                </cmp-carousel-slider>
            </div>
        </div>
    </div>
</template>

<script>
    import { isEqual } from 'lodash';
    import { mapGetters } from 'vuex';
    import bemMixin from 'framework/mixins/bem';
    import isMobileMixin from 'framework/mixins/is-mobile';


    export default {
        mixins: [
            bemMixin('media-portal'),
            isMobileMixin,
        ],
        props: {
            initialItem: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                idx: 0,
            };
        },
        computed: {
            ...mapGetters(['gallery']),
            sortedItems() {
                return this.gallery.items.sort((a, b) => {
                    return b.positionId - a.positionId;
                });
            },
        },
        methods: {
            updateIdx(val) {
                this.idx = val;
            },
        },
        watch: {
            initialItem: {
                handler(val) {
                    if (val == null) {
                        this.idx = 0;
                        return;
                    }

                    this.idx = this.sortedItems.findIndex(item => isEqual(this.initialItem.positionId, item.positionId));
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/media-portal/index.vue?95c71cb4